import _ from 'lodash';
import React from 'react';
import Debug from 'debug';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

const debug = Debug('delectable');

class Error extends React.Component {
  static propTypes = {
    code    : React.PropTypes.number,
    message : React.PropTypes.string
  };
  static defaultProps = {
    code    : 404,
    message : "Sorry, the page you're looking for doesn't exist."
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    return (
      <div className={styles.error}>
        <h1 className={styles.headerCode}>{this.props.code}</h1>
        <h2 className={styles.headerMessage}>{this.props.message}</h2>
      </div>
    );
  }
}

export default Error;



// WEBPACK FOOTER //
// banquet/components/ErrorPage/index.js